import api from '../api/axios';
import { StoryRunEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '/api';
const withBase = (path: string) => `${BASE}${path}`;

export const getRunsByBase = async (baseId: string) => {
  const res = await api.get(withBase(`/story-runs/by-base/${baseId}`));
  return res.data as StoryRunEntity[];
};

export type StartRunPayload = {
  baseStoryId: string;
  referenceImageUrl?: string;
  isDialog?: boolean;
  maxImageCount?: number;
  totalNarrationMs?: number;
  imageIntervalSeconds?: number;
  userNote?: string;
  imageFile?: File | Blob | null;
};

export const startRun = async (payload: StartRunPayload) => {
  const fd = new FormData();
  fd.append('baseStoryId', payload.baseStoryId);
  if (payload.referenceImageUrl) fd.append('referenceImageUrl', payload.referenceImageUrl);
  if (typeof payload.isDialog === 'boolean') fd.append('isDialog', String(payload.isDialog));
  if (typeof payload.maxImageCount === 'number') fd.append('maxImageCount', String(payload.maxImageCount));
  if (typeof payload.totalNarrationMs === 'number') fd.append('totalNarrationMs', String(payload.totalNarrationMs));
  if (typeof payload.imageIntervalSeconds === 'number') fd.append('imageIntervalSeconds', String(payload.imageIntervalSeconds));
  if (payload.userNote) fd.append('userNote', payload.userNote);
  if (payload.imageFile) fd.append('imageData', payload.imageFile);
  const res = await api.post(withBase(`/run/start`), fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const startRun2 = async (storyRunId: string) => {
  const res = await api.post(withBase(`/run/start2`), { storyRunId });
  return res.data as { success?: boolean; message?: string } | any;
};

export const getRunById = async (id: string) => {
  const res = await api.get(withBase(`/story-runs/${id}`));
  return res.data as any;
};

export type StoryRunUpdateRequest = {
  status?: string;
  mode?: string;
  estimatedDurationMs?: number | null;
  imageCount?: number | null;
  baseImageUrl?: string | null;
  thumbnail?: string | null;
  userNote?: string | null;
  imagePlanJson?: any[];
};

export type UpdateRunResponse = {
  result: any;
  message?: string;
};

export const updateRun = async (id: string, payload: StoryRunUpdateRequest) => {
  const res = await api.patch(withBase(`/story-runs/${id}`), payload);
  return res.data as UpdateRunResponse;
};

export const deleteRun = async (id: string) => {
  const res = await api.delete(withBase(`/story-runs/${id}`));
  return res.data as { success?: boolean; message?: string } | null;
};

export type TtsDialogOneRequest = {
  storyRunId: string;
  index: number;
  force?: boolean;
  speaking_rate?: number;
  stability?: number;
};

export type TtsDialogOneResponse = {
  storyRunId: string;
  index: number;
  processed?: boolean;
  skipped?: boolean;
  audioUrl?: string | null;
};

export const ttsDialogOne = async (payload: TtsDialogOneRequest) => {
  const res = await api.post(withBase(`/run/tts-dialog-one`), payload);
  return res.data as TtsDialogOneResponse;
};

export type TtsStepRedoResponse = { id: string; audioUrl: string };

export const ttsStepRedo = async (stepId: string, opts?: { speaking_rate?: number; stability?: number }) => {
  const body: any = { stepId };
  if (typeof opts?.speaking_rate === 'number') body.speaking_rate = opts.speaking_rate;
  if (typeof opts?.stability === 'number') body.stability = opts.stability;
  const res = await api.post(withBase(`/run/tts-step-redo`), body);
  return res.data as TtsStepRedoResponse;
};

export const ttsStepReplace = async (stepId: string, file: File | Blob) => {
  const fd = new FormData();
  fd.append('stepId', stepId);
  fd.append('file', file);
  const res = await api.post(withBase(`/run/tts-step-replace`), fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data as TtsStepRedoResponse;
};

const storyRunService = {
  getRunsByBase,
  startRun,
  startRun2,
  getRunById,
  updateRun,
  deleteRun,
  ttsDialogOne,
  ttsStepRedo,
  ttsStepReplace,
};

export default storyRunService;
